import axios from 'axios';

const baseUrl = window.config.API_URL;

const gettingLinkList = async (linkListData) => {
  const token = JSON.parse(localStorage.getItem('user'))?.token || '0';
  const userId = JSON.parse(localStorage.getItem('user'))?.userid || '0';
  const path = `/api/user/getUserBlock/${userId}/${token}`;
  const url = baseUrl + path;
  let data = '';
  if (linkListData?.linkId) {
    data = {
      linkId: linkListData?.linkId,
    };
  }

  const response = await axios.post(url, data);
  return response.data;
};

// ____________________deleting_____________ALL link Block_____________
const deletingAllBlock = async (data) => {
  const path = `/api/user/deleteAllLinkBlock/${data}`;
  const url = baseUrl + path;
  const response = await axios.delete(url);
  return response.data;
};

const linkListService = {
  gettingLinkList,
  deletingAllBlock,
};

export default linkListService;
